export default __webpack_public_path__ + "static/media/UBER.dc756568.png";